module.exports = __webpack_public_path__ + "images/c985ca2a06ee9ac4e47c564ab634b5ff.png";